import { z } from "zod";

export const InboxItemSchema = z.object({
  RequestId: z.number().optional(),
  ReferenceNumber: z.string(),
  CompanyName: z.string(),
  CreatedDate: z.string().or(z.date()),
  Remarks: z.string().optional(),
  ApplicationType: z.string().optional(),
  UpdatedDate: z.string().or(z.date()).or(z.number()),
  CreatedByName: z.string(),
  ContractNo: z.string().optional(),
  ContractName: z.string().optional(),
  RequestStatus: z.string().optional(),
  IsDraft: z.boolean().optional(),
});

export const FlatInboxSchema = z.array(InboxItemSchema);

export const InboxResponseFlatSchema = FlatInboxSchema;
export const TrackingResponseFlatSchema = FlatInboxSchema;

export const InboxResponseSchema = z.object({
  LoaInbox: z.array(InboxItemSchema),
});

export const InboxCancelRequestSchema = z.object({
  RequestId: z.number(),
  ReferenceNo: z.string(),
  IsCancelled: z.boolean(),
});

export type InboxItem = z.infer<typeof InboxItemSchema>;

export type InboxResponse = z.infer<typeof InboxResponseSchema>;

export type InboxFlatResponse = z.infer<typeof InboxResponseFlatSchema>;
export type TrackingFlatResponse = z.infer<typeof TrackingResponseFlatSchema>;

export type InboxCancelRequest = z.infer<typeof InboxCancelRequestSchema>;

export interface InboxPayload {
  email: string;
  filters?: string;
  filterText?: string;
  pageNumber: number;
  pageSize: number;
}
